import { __awaiter } from "tslib";
import { MedicalAdmissionService } from "@/servicesTs/models/medicalAdmission/medicalAdmission";
const moduleMedicalAdmission = {
    namespaced: true,
    state: {
        loading: false,
        tableMedicalAdmissionActive: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
        tableMedicalAdmissionEgress: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
        dataFilter: {
            rut: null,
            medical_admission_id: null,
            patient_name: null,
            patient_apepat: null,
            patient_apemat: null,
            mh_number: null,
            node_id: localStorage.getItem("stablishment"),
        },
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getTableMedicalAdmissionActive(state) {
            return state.tableMedicalAdmissionActive;
        },
        getTableMedicalAdmissionEgress(state) {
            return state.tableMedicalAdmissionEgress;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setDataFilter(state, data) {
            state.dataFilter.rut = data.rut;
            state.dataFilter.medical_admission_id = data.medical_admission_id;
            state.dataFilter.patient_name = data.patient_name;
            state.dataFilter.patient_apepat = data.patient_apepat;
            state.dataFilter.patient_apemat = data.patient_apemat;
            state.dataFilter.mh_number = data.mh_number;
        },
        setTableMedicalAdmissionActive(state, data) {
            state.tableMedicalAdmissionActive = data;
        },
        setTableMedicalAdmissionEgress(state, data) {
            state.tableMedicalAdmissionEgress = data;
        },
        setPageTableMedicalAdmissionActive(state, page) {
            state.tableMedicalAdmissionActive.current_page = page;
        },
        setPageTableMedicalAdmissionEgress(state, page) {
            state.tableMedicalAdmissionEgress.current_page = page;
        },
    },
    actions: {
        getTableMedicalAdmissionActive({ commit, state }) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                commit("setTableMedicalAdmissionActive", []);
                let MEDICAL_ADMISSION_ACTIVE = yield MedicalAdmissionService.getFilter(Object.assign(Object.assign({}, state.dataFilter), { node_id: localStorage.getItem("stablishment"), state: "activo", page: state.tableMedicalAdmissionActive.current_page }));
                MEDICAL_ADMISSION_ACTIVE.data = (_a = MEDICAL_ADMISSION_ACTIVE.data) === null || _a === void 0 ? void 0 : _a.map((medicalAdmission) => {
                    var _a;
                    return Object.assign(Object.assign({}, medicalAdmission), { medical_admision_activity: (_a = medicalAdmission.medical_admission_activities) === null || _a === void 0 ? void 0 : _a.map((medicalAdmissionActivity) => {
                            var _a, _b, _c, _d;
                            let professionals = [];
                            if ((_a = medicalAdmissionActivity.prof_rces_history_mental_health) === null || _a === void 0 ? void 0 : _a.length) {
                                (_b = medicalAdmissionActivity.prof_rces_history_mental_health) === null || _b === void 0 ? void 0 : _b.forEach((profRce) => {
                                    var _a;
                                    professionals.push({
                                        name: ((_a = profRce.professional) === null || _a === void 0 ? void 0 : _a.full_name) || "",
                                    });
                                });
                            }
                            if ((_c = medicalAdmissionActivity.schedules_citations) === null || _c === void 0 ? void 0 : _c.length) {
                                (_d = medicalAdmissionActivity.schedules_citations) === null || _d === void 0 ? void 0 : _d.forEach((scheduleCitation) => {
                                    var _a, _b, _c;
                                    professionals.push({
                                        name: `${(_a = scheduleCitation.professional) === null || _a === void 0 ? void 0 : _a.name} ${(_b = scheduleCitation.professional) === null || _b === void 0 ? void 0 : _b.apepat} ${(_c = scheduleCitation.professional) === null || _c === void 0 ? void 0 : _c.apemat}`,
                                    });
                                });
                            }
                            return Object.assign(Object.assign({}, medicalAdmissionActivity), { professionals: professionals });
                        }) });
                });
                commit("setTableMedicalAdmissionActive", MEDICAL_ADMISSION_ACTIVE);
                commit("setLoading", false);
            });
        },
        getTableMedicalAdmissionEgress({ commit, state }) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                commit("setTableMedicalAdmissionEgress", []);
                let MEDICAL_ADMISSION_EGRESS = yield MedicalAdmissionService.getFilter(Object.assign(Object.assign({}, state.dataFilter), { node_id: localStorage.getItem("stablishment"), state: "egresado", page: state.tableMedicalAdmissionEgress.current_page }));
                MEDICAL_ADMISSION_EGRESS.data = (_a = MEDICAL_ADMISSION_EGRESS.data) === null || _a === void 0 ? void 0 : _a.map((medicalAdmission) => {
                    var _a;
                    return Object.assign(Object.assign({}, medicalAdmission), { medical_admision_activity: (_a = medicalAdmission.medical_admission_activities) === null || _a === void 0 ? void 0 : _a.map((medicalAdmissionActivity) => {
                            var _a, _b, _c, _d;
                            let professionals = [];
                            if ((_a = medicalAdmissionActivity.prof_rces_history_mental_health) === null || _a === void 0 ? void 0 : _a.length) {
                                (_b = medicalAdmissionActivity.prof_rces_history_mental_health) === null || _b === void 0 ? void 0 : _b.forEach((profRce) => {
                                    var _a;
                                    professionals.push({
                                        name: ((_a = profRce.professional) === null || _a === void 0 ? void 0 : _a.full_name) || "",
                                    });
                                });
                            }
                            if ((_c = medicalAdmissionActivity.schedules_citations) === null || _c === void 0 ? void 0 : _c.length) {
                                (_d = medicalAdmissionActivity.schedules_citations) === null || _d === void 0 ? void 0 : _d.forEach((scheduleCitation) => {
                                    var _a, _b, _c;
                                    professionals.push({
                                        name: `${(_a = scheduleCitation.professional) === null || _a === void 0 ? void 0 : _a.name} ${(_b = scheduleCitation.professional) === null || _b === void 0 ? void 0 : _b.apepat} ${(_c = scheduleCitation.professional) === null || _c === void 0 ? void 0 : _c.apemat}`,
                                    });
                                });
                            }
                            return Object.assign(Object.assign({}, medicalAdmissionActivity), { professionals: professionals });
                        }) });
                });
                commit("setTableMedicalAdmissionEgress", MEDICAL_ADMISSION_EGRESS);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleMedicalAdmission;
